function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { PureComponent } from "react";
import Button from "/components/core/button/button-component";
import EmailInput from "/components/core/inputs/email-input-component";
import DefaultProps from "./default-props";
import classnames from "classnames";
import withErrorHandler from "/components/enhancements/input-error-handler/input-error-handler";
import { withGenericConfig } from "/contexts/generic-config-context";
import { CLICKED_SIGNUP_WITHOUT_INSERTING_EMAIL } from "/constants/bigbrain-event-types";
import { StyledEmailButton } from "./email-button.scss";
const DEFAULT_CTA_KEY = "signup.cta";
class EmailButton extends PureComponent {
    componentDidMount() {
        const { focusOnLoad, isFirstSegment, isPreview } = this.props;
        if (isPreview) return;
        const shouldFocus = focusOnLoad || isFirstSegment;
        shouldFocus && this.focusOnInput();
    }
    updateEmail(event) {
        const { errorStateCallback, onEmailChange } = this.props;
        errorStateCallback(false);
        onEmailChange(event.target.value);
    }
    getButtonText() {
        const { buttonText, translate } = this.props;
        return buttonText || translate(DEFAULT_CTA_KEY); //removed from default props because of localization
    }
    getPlaceholderText() {
        const { placeholder, translate } = this.props;
        return placeholder || translate("signup.emailInputPlaceholder");
    }
    onClick() {
        const { errorStateCallback, onButtonClick, emailValue } = this.props;
        if (!emailValue) {
            BigBrain("track", CLICKED_SIGNUP_WITHOUT_INSERTING_EMAIL);
        }
        if (!this._emailInput.isValid()) {
            errorStateCallback(true);
            return;
        }
        onButtonClick();
    }
    handleOnClickIfNeeded(event) {
        if (event.key === "Enter") {
            this.onClick();
            event.preventDefault();
        }
    }
    render() {
        const { emailValue, buttonColor, buttonSize, isErrorState, className, borderColor, disableButtonAnimation, placeholderFocusColor, withButtonArrow, buttonSpinnerColor, isLoading, noticeText } = this.props;
        const buttonTextToUse = this.getButtonText();
        const placeholderToUse = this.getPlaceholderText();
        const clickAction = this.onClick;
        return /*#__PURE__*/ _jsxs(StyledEmailButton, {
            className: classnames("email-button", className, {
                error: isErrorState
            }),
            children: [
                /*#__PURE__*/ _jsxs("div", {
                    className: "email-button-inner",
                    children: [
                        /*#__PURE__*/ _jsx(EmailInput, {
                            className: "email-button-input",
                            ref: (el)=>this._emailInput = el,
                            value: emailValue,
                            onChange: this.updateEmail,
                            placeholder: placeholderToUse,
                            onKeyPress: this.handleOnClickIfNeeded,
                            autoComplete: "on",
                            placeholderFocusColor: placeholderFocusColor,
                            style: {
                                borderColor
                            }
                        }),
                        /*#__PURE__*/ _jsx("div", {
                            className: "email-button-wrapper",
                            children: /*#__PURE__*/ _jsxs(Button, {
                                className: "email-button-class",
                                color: buttonColor,
                                size: buttonSize,
                                isLoading: isLoading,
                                onClickCallback: clickAction,
                                disableAnimation: disableButtonAnimation,
                                dataSpinnerColor: buttonSpinnerColor,
                                children: [
                                    /*#__PURE__*/ _jsx("span", {
                                        className: "button-text",
                                        children: buttonTextToUse
                                    }),
                                    withButtonArrow && /*#__PURE__*/ _jsx("span", {
                                        className: "email-button-arrow-wrapper",
                                        children: /*#__PURE__*/ _jsx(RightArrow, {})
                                    })
                                ]
                            })
                        })
                    ]
                }),
                noticeText && /*#__PURE__*/ _jsx("div", {
                    className: "notice-text-wrapper",
                    children: noticeText
                })
            ]
        });
    }
    constructor(props){
        super(props);
        _define_property(this, "focusOnInput", ()=>{
            this._emailInput && this._emailInput.focus();
        });
        this._emailInput = null;
        this.updateEmail = this.updateEmail.bind(this);
        this.handleOnClickIfNeeded = this.handleOnClickIfNeeded.bind(this);
        this.onClick = this.onClick.bind(this);
    }
}
EmailButton.defaultProps = DefaultProps;
export default withErrorHandler(withGenericConfig(EmailButton));
